import { currentClientNotificationApi } from '@cp/entities/client';
import { AsyncResult, Result } from '@cp/shared/result';
import { useCallback } from 'react';
import { usePushNotifications } from 'src/shared/pushNotifications';

export const useNotificationUnsubscribe = () => {
  const pushNotifications = usePushNotifications();
  const [unsubscribeFromWebPushNotifications] = currentClientNotificationApi.endpoints.unsubscribeFromWebpushNotifications.useMutation();

  return useCallback((): AsyncResult<void, Error> => {
    const subscription = pushNotifications.manager.subscription;

    if (!subscription) {
      return Promise.resolve(Result.Ok());
    }
    return Result.fromAsync(() =>
      unsubscribeFromWebPushNotifications({
        endpoint: String(subscription.endpoint),
      }).unwrap(),
    ).then((r) => r.mapError((cause) => new Error('Error while unsubscribe', { cause })));
  }, [unsubscribeFromWebPushNotifications, pushNotifications]);
};
